import { useRef, useState } from "react"
import {
  Heading,
  Stack,
  Text,
  Box,
  HStack,
  Button,
  Center,
  AlertDialog,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react"

import { Link } from "@/components/Link"
import { TableIcon, TrashIcon } from "@/components/Icon"

/**
 *
 * @param {string} title
 * @param {string} id
 * @returns {JSX.Element}
 */
const DatasetSummary = ({
  dataType = "Sample data",
  title,
  id,
  chartsCount,
  deleteDataset,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const onClose = () => setIsOpen(false)
  const cancelRef = useRef()
  return (
    <HStack h="7rem" px="lg" spacing="sm">
      <Center w="3rem" h="3rem" bg="brand.100" borderRadius="full" color="brand.500">
        <TableIcon size="24" />
      </Center>
      <Link href={`/dataset/${id}`} variant="card" flex="1" alignSelf="stretch">
        <Stack spacing="3xs" justifyContent="center" h="100%">
          <Heading variant="datasetTitle">{title || "Untitled"}</Heading>
          <Text variant="datasetSubtitle">{`${chartsCount} chart${chartsCount === 1 ? "" : "s"}`}</Text>
        </Stack>
      </Link>
      <Box>
        <Button
          px="0"
          borderRadius="full"
          variant="ghost"
          color="gray.600"
          onClick={() => setIsOpen(true)}
        >
          <TrashIcon size="16" strokeWidth={1.5} />
        </Button>
        <AlertDialog
          isOpen={isOpen}
          leastDestructiveRef={cancelRef}
          onClose={onClose}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <Stack spacing="lg" mx="md" my="lg">
                <Stack spacing="xs" alignItems="center">
                  <Heading variant="modalTitle">
                    {`Delete ${title} dataset`}
                  </Heading>
                  <Text variant="modalBodyText" textAlign="center">
                    {
                      "Are you sure you want to delete this dataset? You can't undo this action afterwards."
                    }
                  </Text>
                </Stack>

                <HStack spacing="xs" justifyContent="center">
                  <Button ref={cancelRef} onClick={onClose} borderRadius="full">
                    {"Cancel"}
                  </Button>
                  <Button
                    colorScheme="red"
                    onClick={() => {
                      deleteDataset(id)
                      onClose()
                    }}
                    borderRadius="full"
                  >
                    {"Delete dataset"}
                  </Button>
                </HStack>
              </Stack>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </Box>
    </HStack>
  )
}

export default DatasetSummary
